<template>
  <svg class="stat-circle" viewBox="0 0 120 120">
    <circle cx="60" cy="60" r="54" fill="none" stroke="#e6e6e6" stroke-width="10" />
    <circle class="progress" cx="60" cy="60" r="54" fill="none"
            :stroke="progressColor"
            stroke-width="10"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="circleDashOffset"
    />
    <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" transform="rotate(90, 60, 60)">
      {{ percentage }}%
    </text>
  </svg>
</template>


<style scoped lang="scss">
    .stat-circle {
        width: 50%;
        transform: rotate(-90deg);

        .progress {
            animation-name: progressCircle;
            animation-duration: 1s;
        }
    }
</style>

<script>

    export default {
        name: 'EvaluationSubcomponentsProgressCircle',
        props: {percentage: {type: Number, required: true}},
        data() {
            return {
                circumference: 2 * Math.PI * 54
            }
        },
        computed: {
            circleDashOffset() {
                let decimal = this.percentage / 100
                return this.circumference * (1 - decimal)
            },
            progressColor() {
                if (this.percentage >= 75) {
                    return '#66b366'
                }
                if (this.percentage >= 40) {
                    return '#FFCB38'
                }
                return '#ff583b'
            }
        }
    }
</script>
